export const SECRIP_DETAIL = "SECRIP_DETAIL";
export const SECRIP_DETAIL_ERROR = "SECRIP_DETAIL_ERROR";
export const SECRIP_DETAIL_HIDE_ERROR = "SECRIP_DETAIL_HIDE_ERROR";
export const SECRIP_DETAIL_START_LOADER = "SECRIP_DETAIL_START_LOADER";
export const SECRIP_DETAIL_STOP_LOADER = "SECRIP_DETAIL_STOP_LOADER";
